import request from '@/utils/request'

export function page(data) {
  return request({
    url: '/mg/daohang-member-api/memberDay/page',
    method: 'post',
    data,
  })
}

export function list(data) {
  return request({
    // url: '/mg/daohang-member-api/memberDay/list',
    // method: 'post',
    // data,
    url: '/mg/daohang-member-api/memberDay/getDefaultMemberDay',
    method: 'get',
    data
  })
}

export function detail(id) {
  return request({
    url: `/mg/daohang-member-api/memberDay/${id}`,
    method: 'get',
  })
}

export function save(data) {
  return request({
    url: '/mg/daohang-member-api/memberDay',
    method: 'put',
    loading: true,
    data,
  })
}

export function updateStatus(data) {
  return request({
    url: '/mg/daohang-member-api/memberDay/editStatus',
    method: 'post',
    loading: true,
    data,
  })
}

export function memberDayDel(data) {
  return request({
    url: '/mg/daohang-member-api/memberDay',
    method: 'delete',
    loading: true,
    data,
  })
}
